module.exports = __webpack_public_path__ + "1c7c54afd2d86fa920a92d9dedfef9fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/strategie/marketing_video.jpg
// module id = 148
// module chunks = 0